import React, { Component } from 'react';
import _ from 'lodash';
import commonUtil from '../../../../../utils/commonUtil';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import TextInput from '../../../../../components/ZUILib/TextInput';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
export default class TarjetaLiverpool extends Component {
  constructor(props) {
    super(props);
    // this.decimalAdded = false;
    this.state = {
      tarjetaWalletAmount: '0.00',
      isEmployeeHasCards: true,
      transferenceData: this.props.transferenceData,
      selectedRadioSavedCardsInfoValue: this.props.transferenceData?.employeeCardInfo[0]?.accountId ||'',
    };
  }

  componentDidMount() {
    if (
      this.props.transferenceData &&
      this.props.transferenceData?.employeeCardInfo &&
      this.props.transferenceData?.employeeCardInfo[0]?.accountId
    ) {
      document.querySelector('input[name="tarjetaWalletAmount"]').removeAttribute('disabled');
    }
  }

  checkUpdateAmountField = (event) => {
    if (event) {
      const inputName = event.target.name;
      const preValue = this.state[inputName];
      const inputValue = (parseFloat(event.target.value) * 10).toFixed(2);
      const regEx = /^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/;
      if (regEx.test(inputValue)) {
        this.state[inputName] = inputValue;
        this.setState({ [inputName]: inputValue });
      } else {
        this.state[inputName] = preValue;
        this.setState({ [inputName]: preValue });
      }
    }
  }

  handleDisableContinueButton = () => {
    if (this.state.tarjetaWalletAmount.length > 0 && +this.state.tarjetaWalletAmount <= +this.state.transferenceData.transferenceOptions.transferableAmount) {
      _.isEmpty(this.state.selectedRadioSavedCardsInfoValue) ? null : this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  checkKeyDownOnlyNumber = (event) => {
    const inputName = event.target.name;
    const regEx = /\d/;
    if (!regEx.test(Number(event.key)) || event.key === 'Backspace') {
      event.preventDefault();
    }
    if (event.key === 'Backspace') {
      const preValue = (parseFloat(this.state[inputName]).toPrecision() / 10).toFixed(2);
      this.state[inputName] = preValue;
      this.setState({ [inputName]: preValue });
      this.handleDisableContinueButton();
    }
  }
  // key = (e) => {
  //   if (e.which === 43) {
  //     this.decimalAdded = false;
  //   }
  // }
  onTarjetaWalletAmountNumberChange = (e) => {
    /* eslint-disable */
    this.checkUpdateAmountField(e);
    if (e.target.value.length > 0 && +this.state.tarjetaWalletAmount <= +this.state.transferenceData.transferenceOptions.transferableAmount) {
      _.isEmpty(this.state.selectedRadioSavedCardsInfoValue) ? null : this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    } 
    /* eslint-enable */
  }
  handleRadioSelected = (data, e) => {
    this.setState({ selectedRadioSavedCardsInfoValue: e.target.value });
    document.querySelector('input[name="tarjetaWalletAmount"]').removeAttribute('disabled');
  }

  // onExceptionKeysCheckForAmount = (e) => {
  //   this.setState({ test: document.querySelector('#abc').value });
  //   /* eslint-disable */
  //   // if (this.decimalAdded) {
  //   //   if (e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45) {
  //   //     e.preventDefault();
  //   //   } else if (e.target.value.length > 0 && e.which === 46) {
  //   //     e.preventDefault();
  //   //   }
  //   // } else {
  //   //   if (e.target.value.length === 0 && (e.which === 46 || e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45)) {
  //   //     e.preventDefault();
  //   //   } else if (e.which === 43 || e.which === 101 || e.which === 69 || e.which === 45) {
  //   //     e.preventDefault();
  //   //   } else if (e.target.value.length > 0 && e.which === 46) {
  //   //     this.decimalAdded = true;
  //   //   }
  //   // }
  //   /* eslint-enable */
  // }

  getFormData = () => {
    let reqParams = {};
    const employeeCardInfoObj = _.find(this.state.transferenceData.employeeCardInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue });
    reqParams = {
      walletType: employeeCardInfoObj.accountName,
      walletOrEmployeeCardAmount: this.state.tarjetaWalletAmount,
      totalAmount: this.state.transferenceData.transferenceOptions.transferableAmount,
      walletOrEmployeeIdentifierId: this.state.selectedRadioSavedCardsInfoValue,
      accountNumber: _.find(this.state.transferenceData.employeeCardInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue }).accountNumber,
      userName: employeeCardInfoObj.accountHolderName,
    };
    return reqParams;
  }

  render() {
    const iconStyle = {
      fontWeight: 700,
      paddingRight: '1.5%',
      marginTop: '-1%',
    };

    const employeeCardInfo = {
      name: 'cardsInfo',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.employeeCardInfo) {
      this.state.transferenceData.employeeCardInfo.map(card =>
        employeeCardInfo.options.push({
          id: 'radio_' + card.accountId,
          value: card.accountId,
          displayName: <span>{card.accountName} {card.accountHolderName}</span>,
          subDetailsHTML: <p>{card.accountNumber}</p>,
          selected: false,
        }),
      );
    }

    return (
      <div>
        {channel === constChannels.WAP ?
          <div>
            <div className="stepTwoOption">
              <div className="row show-grid-row">
                <div className="col-xs-12">
                  <div className="formBlock accountTransference">
                    {
                    this.state.isEmployeeHasCards ?
                      <div className="row display-block">
                        <div className="col-xs-12">
                          <div>
                            {employeeCardInfo.options.map((option, index) => (
                              <div className="row" key={index}>
                                <div className="col-xs-12">
                                  <RadioButton
                                    checked={this.state.selectedRadioSavedCardsInfoValue === option.value}
                                    displayName={option.displayName}
                                    id={option.id}
                                    value={option.value}
                                    name="savedCardInfo"
                                    radioCssClass={'radio selectCard'}
                                    onChangeFunction={this.handleRadioSelected}
                                  />
                                  <TextInput
                                    className="inputMaterial"
                                    style={{ padding: '8px 0 8px 5px' }}
                                    labelClassName="placeHolderMaterial"
                                    inputValue={option.subDetailsHTML.props.children.replaceAll('X', '*')}
                                    readOnly
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      : null
                  }
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      star="*"
                      onChange={this.onTarjetaWalletAmountNumberChange}
                      onKeyDown={this.checkKeyDownOnlyNumber}
                      name="tarjetaWalletAmount"
                      inputValue={this.state.tarjetaWalletAmount}
                      label="Cantidad a retirar"
                      maxlength="16"
                      required
                      disabled
                      type="number"
                    />
                  </div>
                </div>
                <div className="col-xs-12">
                  <i
                    className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                    style={iconStyle}
                  >
                    <span className="tooltip-box">
                      <p style={{ fontWeigt: 600 }}>Monto disponible</p>
                      {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}</span>
                  </i>
                  <span className="text" style={{ fontSize: '16px' }}>Disponible para retiro</span>&nbsp;&nbsp;
                  <p className="articleName alignHelp" style={{ fontSize: '16px' }}>
                    {commonUtil.getCurrency(this.props.transferenceData.transferenceOptions.transferableAmount)}
                  </p>
                </div>
              </div>
            </div>
          </div>
          :
          // code for web
          <div>
            <div className="stepTwoOption">
              <div className="row show-grid-row">
                <div className="col-xs-7">
                  <div className="formBlock">
                    {
                    this.state.isEmployeeHasCards ?
                      <div className="row display-block">
                        <div className="col-xs-6">
                          <div>
                            {employeeCardInfo.options.map((option, index) => (
                              <div className="row" key={index}>
                                <div className="col-xs-12">
                                  <RadioButton
                                    style={{ fontSize: '16px' }}
                                    checked={this.state.selectedRadioSavedCardsInfoValue === option.value}
                                    displayName={option.displayName}
                                    id={option.id}
                                    value={option.value}
                                    name="savedCardInfo"
                                    radioCssClass={'radio selectCard'}
                                    onChangeFunction={this.handleRadioSelected}
                                  />
                                  <TextInput
                                    style={{ padding: '12px 0 12px 5px' }}
                                    className="inputMaterial"
                                    labelClassName="placeHolderMaterial"
                                    inputValue={option.subDetailsHTML.props.children.replaceAll('X', '*')}
                                    readOnly
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      : null
                  }
                    <div className="col-xs-6" style={{ paddingLeft: 0 }}>
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        star="*"
                        onChange={this.onTarjetaWalletAmountNumberChange}
                        onKeyDown={this.checkKeyDownOnlyNumber}
                        name="tarjetaWalletAmount"
                        inputValue={this.state.tarjetaWalletAmount}
                        label="Cantidad a retirar"
                        maxlength="16"
                        disabled
                        required
                      />
                    </div>

                  </div>
                </div>
                <div className="col-xs-7" style={{ fontSize: '16px' }}>
                  <i
                    className="iClass icon-ayuda tooltip-container text-pink"
                    style={iconStyle}
                  >
                    <span className="tooltip-box tooltipIcon344" style={{ width: '300px' }}>
                      {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}</span>
                  </i>
                  <span className="text">Disponible para retiro</span>&nbsp;&nbsp;
                  <div className="quantityBlock"><strong className="quantity">{commonUtil.getCurrency(this.props.transferenceData.transferenceOptions.transferableAmount)}</strong></div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    );
  }

}
